import { supabase } from '../../../shared/api/supabaseClient.js';

const messages = {
  union_check_rate_limited: '잠시 후 다시 확인해주세요. 소속 확인은 1분에 한 번 가능합니다.',
  verified_union_required: '게임 유니온을 확인하지 못했습니다. BlablaLink 소속을 확인해주세요.',
  game_union_unavailable: '게임 소속을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.',
  blablalink_session_not_configured: '게임 정보 연결을 점검 중입니다. 잠시 후 다시 시도해주세요.',
  game_profile_identity_mismatch: '인증된 게임 계정과 조회 결과가 일치하지 않습니다.',
  union_check_expired: '확인 시간이 지났습니다. 현재 유니온을 다시 확인해주세요.',
  union_membership_changed: '소속이나 권한이 변경되었습니다. 현재 유니온을 다시 확인해주세요.',
  leadership_transfer_required: '주딱을 위임한 뒤 소속을 전환할 수 있습니다.',
  union_not_active: '새 유니온이 승인 대기 또는 이용 정지 상태입니다.',
};
function failure(code) {
  return new Error(messages[Object.keys(messages).find(key => String(code).includes(key))] || '소속을 처리하지 못했습니다. 다시 시도해주세요.');
}
export async function checkCurrentUnion() {
  if (!supabase) throw failure('');
  const { data, error } = await supabase.functions.invoke('check-current-union', { body: {} });
  if (error) {
    let details;
    try { details = await error.context?.json(); } catch { /* Use the generic message. */ }
    throw failure(details?.code || error.message);
  }
  if (!data?.ok || !data.id) throw failure(data?.code);
  return data;
}
export async function confirmUnionTransfer(checkId) {
  const { data, error } = await supabase.rpc('confirm_union_transfer', { check_id: checkId });
  if (error || !data?.ok) throw failure(error?.message);
  return data;
}
